module.exports = __webpack_public_path__ + "img/resource08.7e347b1b.png";